import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineArrowToRightIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m17.71 11.29-4-4a1.003 1.003 0 0 0-.71-.294 1.0036 1.0036 0 0 0-.71.294 1.0052 1.0052 0 0 0-.2177 1.0942c.0505.1219.1245.2326.2177.3258l2.3 2.29H3a1.0002 1.0002 0 0 0-.7071 1.7071C2.4804 12.8946 2.7348 13 3 13h11.59l-2.3 2.29a.9997.9997 0 0 0 0 1.42.9997.9997 0 0 0 1.42 0l4-4a1.0012 1.0012 0 0 0 .21-.33c.1-.2435.1-.5165 0-.76a1.0002 1.0002 0 0 0-.21-.33ZM21 4a1 1 0 0 0-1 1v14a1.0001 1.0001 0 0 0 2 0V5a1.0002 1.0002 0 0 0-1-1Z"/>
  </SvgIcon>
}

export default LineArrowToRightIcon
